import Head from 'next/head';
import React from 'react';
import { ErrorsPage } from '../../modules/docs/errors/components';

const Errors = () => {
	return (
		<React.Fragment>
			<Head>
				<title>Dummy API Error Handling Documentation</title>
				<meta name="description" content="DummyAPI Documentation, Error types, how to handle errors in dummyapi" />
			</Head>
			<ErrorsPage />
		</React.Fragment>
	);
};

export default Errors;
